import { PaymentMethodPreset } from '@cpce/database/enums';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PrestationTransactionCreationPage } from '@/features/beneficiaries/employees/transactions/components/PrestationTransactionCreationPage';

const searchSchema = z.object({
  employeeId: z.coerce.number().optional(),
  prestationParticipationIds: z.coerce.number().array().optional(),
  label: z.string().optional(),
  /** Pre-selects the CSE's mode de règlement of that kind, when it has exactly one. */
  paymentPreset: z.enum(PaymentMethodPreset).optional(),
});

export const Route = createFileRoute('/$commiteeSlug/beneficiaries/transactions/create/')({
  component: PrestationTransactionCreationPage,
  validateSearch: searchSchema,
});
